import { NgRedux, select } from '@angular-redux/store';
import { Injectable } from '@angular/core';
import { ExclusiveRewardItem, ExclusiveRewards, RewardSummaryItems } from '@app/core/models/loyalty.model';
import { Actions, IAppState, LocationsEntity, LoyaltyMode, User } from '@app/core/redux/stores';
import { ProxyService } from '@app/core/services';
import { ApiRoutes } from '@app/shared/models/configs/api.endpoints';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';
import { MessageSummaryLoyalty } from '../../account/messaging/models';

@Injectable({
  providedIn: 'root'
})
export class RewardService {
  loyaltyMode: LoyaltyMode;
  points: any;
  @select((appState) => appState.user) userObject: Observable<User>;
  @select((appState) => appState.auth.isLoggedIn) isLoggedIn?: Observable<boolean>;
  isUserSignedIn: boolean;


  constructor(private http: ProxyService,
    private ngRedux: NgRedux<IAppState>) { 
    this.loyaltyMode = environment.LOYALTY_MODE;
    this.isLoggedIn.subscribe(
      val => {
        this.isUserSignedIn = val;
      }
    );
  }
  getRewardSummary() {
    return this.http.httpGet(ApiRoutes.REWARD_SUMMARY).toPromise().then(
      (success) => {
        const response = <MessageSummaryLoyalty>success.body.valueOf();
          this.points = response?.points as number;
          response.loyaltyMode = this.loyaltyMode;
          if(this.isUserSignedIn) {
            this.updateUserPoints();
          }               
          return response;
      }).catch((error) => {
        const response = new MessageSummaryLoyalty();
        response.loyaltyMode = this.loyaltyMode;
        return response;
      });
  }
  public updateUserPoints(points = null) {
    this.userObject.subscribe(user => {
      user.loyaltyMode = environment.LOYALTY_MODE;
      user.points = points ?? this.points;
      this.ngRedux.dispatch({ type: Actions.UPDATEUSERPROFILE, data: user });
    });
  }

  getMyConvertedRewards() :Promise<RewardSummaryItems> {
    return this.http.httpGet(ApiRoutes.GET_POINTS).toPromise().then(
      succ => {
        const rewardSummary = <RewardSummaryItems>succ.body.valueOf(); 
        this.points = rewardSummary?.points;
        return  <RewardSummaryItems>succ.body.valueOf();                  
      }).catch(
        ()=> null
      );
  }
  getExclusiveRewardsByLocation(location: LocationsEntity) :Promise<ExclusiveRewards> {
    return this.http.httpGet(ApiRoutes.EXCLUSIVE_REWARDS).toPromise().then(
      succ => {
        const rewards =  <ExclusiveRewards>succ.body.valueOf();
        return this.filterExclusiveRewardsListByLocation(location, rewards);                  
      }).catch(
        ()=> null
      );
  }
  private filterExclusiveRewardsListByLocation(location: LocationsEntity, exclusiveRewards: ExclusiveRewards): ExclusiveRewards {
    exclusiveRewards.items = exclusiveRewards?.items.filter(rewardItem =>
      ((rewardItem.includedRegions.length == 0 || 
        rewardItem.includedRegions?.find(r => r == location.unit || r == location.area || r == location.zone || r == location.region)) 
        && !rewardItem.excludedRegions?.find(r => r == location.unit || r == location.area || r == location.zone || r == location.region)));
    return exclusiveRewards;
  }
}
